import { XMarkIcon } from '@heroicons/react/24/outline'

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const GridSolicitudCuotasMes = ({ setOpen, cuotas = [] }) => {
    
    return (
        <div className="w-[full] lg:max-w-[50%] mx-auto mt-5 px-8 pt-5 pb-8 bg-secundarioMira rounded-lg shadow-xl">
            <div className="sticky top-20 flex justify-between">
                <button
                    type="button"
                    className="p-2 rounded-md bg-grisMira text-white shadow-sm border-2 border-grisMira hover:bg-secundarioMira hover:border-white"
                    onClick={() => setOpen(false)}
                >
                    <span className="sr-only">Close</span>
                    <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                </button>
            </div>
            <div className="sm:px-6 lg:px-8 bg-primarioMira p-5 pb-0 rounded-lg shadow-2xl divide-grisMira border border-grisMira">
                <div className="sm:flex sm:items-center">
                    <div className="sm:flex-auto">
                        <h1 className="text-lg font-semibold text-white">Detalle de cuotas</h1>
                        <p className="mt-1 text-sm text-grisMira">
                            Descuentos incluidos.
                        </p>
                    </div>
                </div>
                <div className="mt-2 flex flex-col">
                    <div className="-mx-4 sm:-mx-6 lg:-mx-8 overflow-auto">
                        <div className="inline-block min-w-full align-middle">
                            <div className="shadow-sm ring-1 ring-black ring-opacity-5">
                                <table className="min-w-full border-separate divide-grisMira border border-grisMira" style={{ borderSpacing: 0 }}>
                                    <thead className="bg-secundarioMira">
                                        <tr>
                                            <th
                                                scope="col"
                                                className="sticky top-0 z-10 bg-secundarioMira border-b border-grisMira py-3.5 pl-4 pr-3 text-center text-sm font-semibold text-grisMira"
                                            >
                                                MES
                                            </th>
                                            <th
                                                scope="col"
                                                className="sticky top-0 z-10 bg-primarioMira border-b border-grisMira py-3.5 pl-4 pr-3 text-center text-sm font-semibold text-grisMira"
                                            >
                                                CUOTAS VARIABLES
                                            </th>
                                            <th
                                                scope="col"
                                                className="sticky top-0 z-10 bg-secundarioMira border-b border-grisMira py-3.5 pl-4 pr-3 text-center text-sm font-semibold text-grisMira sm:pl-6 lg:pl-8"
                                            >
                                                CUOTAS NIVELADAS
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody className="bg-secundarioMira">
                                        {cuotas.map((cuota, Idx) =>
                                            <tr key={Idx}>
                                                <td
                                                    className={classNames(
                                                        Idx !== cuota.length - 1 ? 'border-b-2 border-b-primarioMira' : '',
                                                        'whitespace-nowrap py-2 pr-3 text-sm font-medium text-white text-center'
                                                    )}
                                                >
                                                    {cuota.Colegiatura}
                                                </td>
                                                <td
                                                    className={classNames(
                                                        Idx !== cuota.length - 1 ? 'border-b-2 border-b-secundarioMira' : '',
                                                        'whitespace-nowrap py-2 pr-3 text-sm font-medium text-white text-center bg-primarioMira'
                                                    )}
                                                >
                                                    {Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(cuota.CuotaVariable)}
                                                </td>
                                                <td
                                                    className={classNames(
                                                        Idx !== cuota.length - 1 ? 'border-b-2 border-b-primarioMira' : '',
                                                        'whitespace-nowrap py-2 pr-3 text-sm font-medium text-white text-center'
                                                    )}
                                                >
                                                    {Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(cuota.CuotaNivelada)}
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </div>
    )
}

export default GridSolicitudCuotasMes